const state = {
  previewTemplate: null,
}

const mutations = {
  SET_PREVIEWTEMPLATE: (state,data) => {
    state.previewTemplate = data
  }
}

const actions = {
  setPreviewTemplate({ commit }, data) {
    commit('SET_PREVIEWTEMPLATE', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/electronicLetter.js